import { httpClient } from "@services/api/httpClient";

export async function updateOfferTechnicalAssesmentQuestions(
  offerId: number,
  questions: { question: string }[]
) {
  const response = await httpClient.put("/offer-technical-assesment/questions", {
    offerId,
    questions
  });
  return response.data;
}